"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = void 0;
const typebox_1 = require("@sinclair/typebox");
const duration_unit_1 = require("./duration-unit");
exports.Duration = typebox_1.Type.Object({
    value: typebox_1.Type.Number(),
    unit: duration_unit_1.DurationUnit,
});
//# sourceMappingURL=duration.js.map